import { Injectable } from '@angular/core';
import { Deserializable } from '../models/deserializable';

@Injectable()
export class DeserializableObjectsService {
  public clone<T extends Deserializable>(type: new () => T, source: T): T {
    const clonedObj: T = new type();
    clonedObj.deserialize(source);

    return clonedObj;
  }
}
